import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { enumWorkflowState } from '../../../dataObjects/enums';
import { IImageLink } from '../../../dataObjects/models/digitalMedia/ImageLink';

const initialState: enumWorkflowState | null = null;

export const imageLinkExpungeStatusSlice = createSlice({
  name: 'imageLinkExpungeStatus',
  initialState: enumWorkflowState.None,
  reducers: {
    // action has a payload with IImageLink
    imageLinkExpungeRequest: (state: enumWorkflowState | null, action: PayloadAction<IImageLink>) => {
      // return the workflow state of 'Requested' to indicate that the operation has been requested
      return enumWorkflowState.Requested;
    },
    // action has a payload with the new enumWorkflowState value or null
    imageLinkExpungeStatusChange(state, action) {
      // change status of process
      return action.payload;
    },
  },
})

// Action creators are generated for each function in reducer
export const { imageLinkExpungeRequest, imageLinkExpungeStatusChange } = imageLinkExpungeStatusSlice.actions;

// export the core reducer for the slice
export const imageLinkExpungeStatusReducer = imageLinkExpungeStatusSlice.reducer;

export default imageLinkExpungeStatusSlice.reducer;